<form [formGroup]="form" class="tester-form">
  <div class="row">
    <div class="col-lg-4 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>País / Idioma</mat-label>
        <mat-select formControlName="language">
          <mat-option *ngFor="let opt of languageOptions" [value]="opt.value">
            {{ opt.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Tipo de oferta *</mat-label>
        <mat-select formControlName="offer_type">
          <mat-option value="products">Productos</mat-option>
          <mat-option value="services">Servicios</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12" *ngIf="isProducts">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Tipo de producto</mat-label>
        <mat-select formControlName="product_type">
          <mat-option value="elaborated">Elaborado (yo lo fabrico)</mat-option>
          <mat-option value="purchased">Comprado / reventa</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- Producto elaborado -->
  <ng-container *ngIf="isElaborated">
    <mat-divider class="mt-10 mb-15"></mat-divider>
    <p class="text-muted mb-10" style="font-size: 13px;">Costos de producción:</p>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Costo de materiales</mat-label>
          <input matInput formControlName="elab_materials" type="number" />
        </mat-form-field>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Horas de mano de obra</mat-label>
          <input matInput formControlName="elab_hours" type="number" />
        </mat-form-field>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Valor hora</mat-label>
          <input matInput formControlName="elab_value_hour" type="number" />
        </mat-form-field>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>¿Pagas arriendo?</mat-label>
          <mat-select formControlName="elab_rent_option">
            <mat-option value="no">No</mat-option>
            <mat-option value="yes">Sí</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <ng-container *ngIf="form.get('elab_rent_option')?.value === 'yes'">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Arriendo mensual</mat-label>
            <input matInput formControlName="elab_rent_monthly" type="number" />
          </mat-form-field>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Horas de uso del local al mes</mat-label>
            <input matInput formControlName="elab_rent_hours" type="number" />
          </mat-form-field>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <!-- Producto comprado -->
  <ng-container *ngIf="isPurchased">
    <mat-divider class="mt-10 mb-15"></mat-divider>
    <p class="text-muted mb-10" style="font-size: 13px;">Costos de compra / reventa:</p>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Costo de compra</mat-label>
          <input matInput formControlName="purchased_cost" type="number" />
        </mat-form-field>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Horas invertidas</mat-label>
          <input matInput formControlName="purchased_hours" type="number" />
        </mat-form-field>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Valor hora</mat-label>
          <input matInput formControlName="purchased_value_hour" type="number" />
        </mat-form-field>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>¿Pagas arriendo?</mat-label>
          <mat-select formControlName="purchased_rent_option">
            <mat-option value="no">No</mat-option>
            <mat-option value="yes">Sí</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <ng-container *ngIf="form.get('purchased_rent_option')?.value === 'yes'">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Arriendo mensual</mat-label>
            <input matInput formControlName="purchased_rent_monthly" type="number" />
          </mat-form-field>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Horas de uso del local al mes</mat-label>
            <input matInput formControlName="purchased_rent_hours" type="number" />
          </mat-form-field>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <!-- Servicios -->
  <ng-container *ngIf="isServices">
    <mat-divider class="mt-10 mb-15"></mat-divider>
    <p class="text-muted mb-10" style="font-size: 13px;">Costos del servicio:</p>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Horas del servicio</mat-label>
          <input matInput formControlName="service_hours" type="number" />
        </mat-form-field>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Valor hora</mat-label>
          <input matInput formControlName="service_value_hour" type="number" />
        </mat-form-field>
      </div>
      <div class="col-lg-4 col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>¿Pagas arriendo?</mat-label>
          <mat-select formControlName="rent_yes_no">
            <mat-option value="no">No</mat-option>
            <mat-option value="yes">Sí</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <ng-container *ngIf="form.get('rent_yes_no')?.value === 'yes'">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Arriendo mensual</mat-label>
            <input matInput formControlName="rent_monthly" type="number" />
          </mat-form-field>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Horas de uso del local al mes</mat-label>
            <input matInput formControlName="rent_hours" type="number" />
          </mat-form-field>
        </div>
      </ng-container>
    </div>
  </ng-container>

  <mat-divider class="mt-10 mb-15"></mat-divider>
  <p class="text-muted mb-10" style="font-size: 13px;">Otros costos (opcional, hasta 4):</p>
  <div class="row">
    <ng-container *ngFor="let i of [1, 2, 3, 4]">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Nombre costo {{ i }}</mat-label>
          <input matInput [formControlName]="'other_cost_' + i + '_name'" />
        </mat-form-field>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Valor costo {{ i }}</mat-label>
          <input matInput [formControlName]="'other_cost_' + i + '_value'" type="number" />
        </mat-form-field>
      </div>
    </ng-container>
  </div>

  <mat-divider class="mt-10 mb-15"></mat-divider>
  <div class="row">
    <div class="col-lg-4 col-md-6 col-sm-12">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>Margen de ganancia final (%) *</mat-label>
        <input matInput formControlName="final_margin" type="number" />
      </mat-form-field>
    </div>
  </div>

  <div class="text-right" style="text-align: right;">
    <button mat-button class="default-btn" type="button" (click)="reset()">Limpiar</button>
    <button
      mat-raised-button
      class="default-btn bg-main-color-blue"
      type="button"
      [disabled]="isLoading"
      (click)="onSubmit()"
    >
      {{ isLoading ? "Calculando..." : "Simular precio" }}
    </button>
  </div>
</form>

<div *ngIf="errorMessage" class="alert-message error-message mt-15">
  {{ errorMessage }}
</div>

<div *ngIf="result" class="result-card mt-15">
  <h5 class="title-color">📊 Resultado de la simulación</h5>
  <div class="row">
    <div class="col-lg-4 col-md-6 col-sm-12">
      <strong>Costo total unitario:</strong> {{ result.totalCost }}
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12"><strong>Margen:</strong> {{ result.margin }}</div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <strong>Precio sugerido:</strong> {{ result.suggestedPrice }}
    </div>
  </div>
</div>
